export default {"src":"/_next/static/media/payment_options_gif.3826becc.gif","height":96,"width":96,"blurWidth":0,"blurHeight":0};